import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Функция guard для проверки ролей пользователя
 * @param allowedRoles - массив разрешенных ролей
 * @param redirectTo - маршрут для редиректа при отсутствии доступа (по умолчанию '/')
 */
export function roleGuard(allowedRoles: string[], redirectTo: string = '/'): CanActivateFn {
  return () => {
    const authService = inject(AuthService);
    const router = inject(Router);

    // Проверяем авторизацию
    if (!authService.isAuthenticated()) {
      console.warn('User not authenticated, redirecting to login');
      router.navigate(['/login']);
      return false;
    }

    // Получаем роли напрямую из localStorage через AuthService
    const userRoles = authService.userRoles();

    // Проверяем роли
    const hasRole = allowedRoles.some(role => userRoles.includes(role));

    if (!hasRole) {
      console.warn(`Access denied. Required roles: ${allowedRoles.join(', ')}. User roles: ${userRoles.join(', ')}`);
      router.navigate([redirectTo]);
      return false;
    }

    console.log(`Access granted. User has required role.`);
    return true;
  };
}
